module.exports = __webpack_public_path__ + "b705f0bf96f9c1c33f203adfe4a4de7f.svg";